<template>
  <div class="futuristic-landing">
    <!-- Vanta Background: Globe on desktop, Dots on mobile.
         v-if (not v-show) so the unused effect is fully torn down and
         its WebGL context is released when crossing the breakpoint. -->
    <VantaGlobeScroll v-if="isDesktop" />
    <VantaDots v-else />

    <!-- Navbar -->
    <Navbar />

    <!-- Content Overlay -->
    <div class="content-overlay">
      <HeroSection />

      <WhyEduversity />

      <Specializations />

      <ProgramsOffered />

      <Benefits />



      <UniversityPartners />

      <AlumniCarousel />

      <FaqSection />
    </div>

    <Footer />
  </div>
</template>

<script setup lang="ts">
useHead({
  title: 'Qspiders Eduversity - Industry-Integrated Learning for Future Engineers',
  meta: [
    { name: 'description', content: 'Partnering with leading universities to help students gain industry-relevant skills, build real-world projects, earn certifications, and accelerate their career readiness alongside their degree.' }
  ]
})

// Responsive Vanta background: globe (desktop) vs dots (mobile).
// Match the same 768px breakpoint used throughout the components so the
// swap lines up with the rest of the responsive layout.
const isDesktop = ref(true)
let mql: MediaQueryList | null = null
const onMqChange = (e: MediaQueryListEvent) => {
  isDesktop.value = e.matches
}

onMounted(() => {
  if (!process.client) return
  mql = window.matchMedia('(min-width: 768px)')
  isDesktop.value = mql.matches
  // Safari < 14 uses addListener; modern browsers use addEventListener.
  if (mql.addEventListener) {
    mql.addEventListener('change', onMqChange)
  } else {
    mql.addListener(onMqChange)
  }
})

onBeforeUnmount(() => {
  if (!mql) return
  if (mql.removeEventListener) {
    mql.removeEventListener('change', onMqChange)
  } else {
    mql.removeListener(onMqChange)
  }
})
</script>

<style scoped>
.futuristic-landing {
  position: relative;
  min-height: 100vh;
  background: var(--bg-primary);
  overflow-x: hidden;
  transition: background-color 0.3s ease;
}

.content-overlay {
  position: relative;
  z-index: 10;
}
</style>
